module.exports = __webpack_public_path__ + "static/media/socialMemedia.235f65b3.jpg";